<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px" inline>
                <el-row :gutter="10">
                  <el-col>
                    <el-form-item label="名称">
                      <el-input
                        v-model="form.admin_name"
                        placeholder="名称"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="代号">
                      <el-input
                        v-model="form.code"
                        placeholder="代号"
                        @keyup.native.enter="search"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="买手组">
                      <el-select
                        v-if="resData"
                        v-model="form.pg_id"
                        placeholder="买手组"
                        filterable
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option
                          v-for="item in picker"
                          :key="item.k"
                          :value="item.k"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <!-- <div class="block"> -->
                    <!-- <span class="demonstration"></span> -->
                    <el-form-item label="角色">
                      <el-cascader
                        v-model="form.role_type"
                        placeholder="角色"
                        :options="options"
                      ></el-cascader>
                    </el-form-item>
                    <!-- </div> -->
                    <el-form-item label="状态">
                      <el-select
                        v-if="resData"
                        v-model="form.status"
                        placeholder="状态"
                      >
                        <el-option label="全部" value=""></el-option>
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                      <el-date-picker
                        v-model="form.create_time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="">
                      <el-button type="primary" @click="search">查询</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          v-if="resData"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据汇总 ：{{ resData.count }}人</div>
          <el-button
            style="margin-left: auto"
            type="warning"
            size="mini"
            @click="AddMember(0)"
            >添加人员
          </el-button>
          <el-button type="success" size="mini" @click="output">导出</el-button>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column prop="admin_name" label="姓名" align="center">
            </el-table-column>
            <el-table-column prop="code" label="代号" align="center">
            </el-table-column>
            <el-table-column
              prop="picker_group_member_role_type"
              label="角色"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="bind_supply_num"
              label="已绑定核心档口"
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="handleClick(scope.row.id)">{{
                  scope.row.bind_supply_num
                }}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="month_hexin_bind_num"
              label="可绑定核心档口数"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pg_name"
              label="绑定买手组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.status == 1">启用</div>
                <div v-if="scope.row.status == 0">禁用</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="" label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="AddMember(scope.row.id)"
                  >编辑</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="showLogList(scope.row.id)"
                  >操作日志
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div v-if="showlog">
      <log :id="id" :log-type="log_type" @onCloseDialog="closeBox"></log>
    </div>
    <div v-if="showbox">
      <edit-member :id="id" @onCloseDialog="closeBox"></edit-member>
    </div>
    <el-dialog
      title="已绑定核心商家"
      :visible.sync="showBindSupplyDialog"
      width="30%"
      :before-close="handleDialogClose"
    >
      <el-table ref="multipleTable" :data="bindSupplyTable.list">
        <el-table-column prop="supply_id" label="商家id"></el-table-column>
        <el-table-column prop="supply_name" label="商家名称"></el-table-column>
        <el-table-column prop="brand_name" label="品牌"></el-table-column>
        <el-table-column prop="bind_time" label="绑定日期"></el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="bindSupplyTable.page"
        background
        layout="total, prev, pager, next, jumper "
        :total="bindSupplyTable.total"
        :page-size="10"
        @current-change="handleBindSupplyPageChange"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" @click="handleDialogClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Log from "./components/Log.vue";
import EditMember from "./components/EditMember";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    Log,
    EditMember,
  },
  data() {
    return {
      log_type: 2,
      id: 0,
      showlog: false,
      showbox: false,
      images: [],
      resData: null,
      form: {
        status: "",
      },
      loading: false, // 加载动画是否显示
      url: "/erp/PickerGroup/pickerGroupMemberList",
      status: "",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      picker: [],
      bindSupplyTable: {
        list: [],
        total: 0,
        page: 1,
        picker_group_member_id: 0,
      },
      showBindSupplyDialog: false,
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "maishou",
          label: "买手",
          children: [
            {
              value: "4",
              label: "头部买手",
            },
            {
              value: "1",
              label: "普通买手",
            },
            {
              value: "3",
              label: "兼职买手",
            },
          ],
        },
        {
          value: "maizhu",
          label: "买助理",
          children: [
            {
              value: "5",
              label: "高级买助",
            },
            {
              value: "2",
              label: "中级买助",
            },
            {
              value: "6",
              label: "初级买助",
            },
          ],
        },
      ],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.fetchData();
    this.getPicker();
  },
  methods: {
    getPicker() {
      this.loading = true;
      this.$http.post("/erp/Common/selectPicker").then((res) => {
        this.loading = false;
        if (res.data.code != 200) {
          return this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
        this.picker = res.data.data;
      });
    },
    showLogList(id) {
      this.id = Number(id);
      this.showlog = true;
    },
    AddMember(id) {
      this.id = Number(id);
      this.showbox = true;
    },
    closeBox() {
      this.showbox = false;
      this.showlog = false;
      this.fetchData();
    },
    handleClick(id) {
      this.showBindSupplyDialog = true;
      this.$http
        .post("/erp/PickerGroup/getBindSupply", {
          picker_group_member_id: id,
          page: this.bindSupplyTable.page,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.bindSupplyTable = res.data.data;
          } else {
            this.showBindSupplyDialog = false;
            this.$message.e("读取失败");
          }
        });
    },
    handleDialogClose() {
      this.showBindSupplyDialog = false;
      this.bindSupplyTable = {
        page: 1,
        picker_group_member_id: 0,
        total: 0,
        list: [],
      };
    },
    handleBindSupplyPageChange(val) {
      this.bindSupplyTable.page = val;
      this.handleClick(this.bindSupplyTable.picker_group_member_id);
    },
    handleAbnormalWork(abnormal_id) {
      this.$prompt("填写备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showInput: true,
      })
        .then(({ value }) => {
          if (!value) {
            return this.$message.warning("请填写备注");
          }
          const arg = { abnormal_id, remark: value };
          this.loading = true;
          this.$http
            .post("/erp/Work/changeAbnormalWorkStatus", arg)
            .then((res) => {
              this.loading = false;
              if (res.data.code != 200) {
                return this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
              this.fetchData();
              return this.$message({
                type: "success",
                message: "操作成功",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.fetchData();
    },
    selectStatus(key) {
      this.form.status = this.status = key;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.demo-form-inline .el-form-item {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/picker/Member.vue